"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9146],{

/***/ 6949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Block_Block; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sizing.js
var props_sizing = __webpack_require__(88270);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Block/Block.js








const Block = (param)=>/*#__PURE__*/ {
    let { utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , sizing ={
        ...props_sizing/* sizingProps */.H6
    } , className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)(...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), ...(0,props_sizing/* sizingClassName */.rs)(sizing), className),
        ...props
    });
};
Block.propTypes = {
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    sizing: props_sizing/* sizingPropTypes */.bm,
    className: prop_types.string
};
/* harmony default export */ var Block_Block = (Block);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js



/***/ }),

/***/ 67478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JX": function() { return /* binding */ Col; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X2": function() { return /* binding */ Row; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88270);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_forward_ref__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52418);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7820);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23720);










const Container = (param)=>{
    let { Tag ="div" , isFluid =false , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("grid-container", isFluid && "fluid", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)(spacing), className),
        children: children
    });
};
Container.propTypes = {
    Tag: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_8__.node.isRequired,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityPropTypes */ .pQ,
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingPropTypes */ .Xj
};
const Row = (param)=>{
    let { forwardRef , Tag ="div" , position ="grid-x" , smCols , mdCols , lgCols , mx =false , px =false , my =false , py =false , center =false , middle =false , justify =false , bottom =false , start =false , spaceBetween =false , className ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , sizing ={
        ..._insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__/* .sizingProps */ .H6
    } , children , ...props } = param;
    // eslint-disable-next-line no-nested-ternary
    const alignItemsProps = start ? "start" : middle ? "center" : bottom ? "end" : null;
    // eslint-disable-next-line no-nested-ternary
    const justifyContentProps = center ? "center" : justify ? "between" : null;
    // eslint-disable-next-line no-nested-ternary
    const alignContentProps = spaceBetween ? "between" : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ref: forwardRef,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)(position, mx && "grid-margin-x", px && "grid-padding-x", my && "grid-margin-y", py && "grid-padding-y", smCols && "small-up-".concat(smCols), mdCols && "medium-up-".concat(mdCols), lgCols && "large-up-".concat(lgCols), ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_9__/* .deepMergeProps */ .p)({
            align: {
                items: alignItemsProps,
                content: alignContentProps
            },
            justify: justifyContentProps
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(utility))), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)(spacing), ...(0,_insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__/* .sizingClassName */ .rs)(sizing), className),
        ...props,
        children: children
    });
};
Row.propTypes = {
    forwardRef: _utils_forward_ref__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
    Tag: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    position: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        "grid-x",
        "grid-y"
    ]),
    mx: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    smCols: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    mdCols: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lgCols: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    middle: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    justify: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    bottom: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    spaceBetween: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_8__.node,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityPropTypes */ .pQ,
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingPropTypes */ .Xj,
    sizing: _insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__/* .sizingPropTypes */ .bm,
    start: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool
};
const Col = (param)=>{
    let { Tag ="div" , forwardRef , auto =false , shrink =false , sm ="" , md ="" , lg ="" , smOffset , mdOffset , lgOffset , smOrder , mdOrder , lgOrder , className ="" , center =false , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , sizing ={
        ..._insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__/* .sizingProps */ .H6
    } , ...props } = param;
    const alignProp = center ? {
        justify: "center"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ref: forwardRef,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("cell", auto && "auto", shrink && "shrink", sm && "small-".concat(sm), md && "medium-".concat(md), lg && "large-".concat(lg), smOffset && "small-offset-".concat(smOffset), mdOffset && "medium-offset-".concat(mdOffset), lgOffset && "large-offset-".concat(lgOffset), smOrder && "small-order-".concat(smOrder), mdOrder && "medium-order-".concat(mdOrder), lgOrder && "large-order-".concat(lgOrder), ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_9__/* .deepMergeProps */ .p)({
            ...alignProp
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(utility))), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)(spacing), ...(0,_insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__/* .sizingClassName */ .rs)(sizing), className),
        ...props,
        children: children
    });
};
Col.propTypes = {
    Tag: prop_types__WEBPACK_IMPORTED_MODULE_8__.elementType,
    auto: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    shrink: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    center: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    smOffset: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    mdOffset: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lgOffset: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    smOrder: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    mdOrder: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    lgOrder: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    className: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    utility: _props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityPropTypes */ .pQ,
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_7__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingPropTypes */ .Xj,
    children: prop_types__WEBPACK_IMPORTED_MODULE_8__.node,
    sizing: _insightfulscience_atomic_react_props_sizing__WEBPACK_IMPORTED_MODULE_2__/* .sizingPropTypes */ .bm,
    forwardRef: _utils_forward_ref__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
};


/***/ }),

/***/ 3197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const noop = ()=>{};
const context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    isOpen: false,
    onToggle: noop,
    onOpen: noop,
    onClose: noop
});
const useHeader = ()=>react__WEBPACK_IMPORTED_MODULE_0__.useContext(context);
/* harmony default export */ __webpack_exports__["Z"] = (context);


/***/ }),

/***/ 38529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Header_Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/Tag.js




const HeaderTag = (param)=>/*#__PURE__*/ {
    let { Tag ="header" , isHero =false , isBorderBottomNone , className ="" , children  } = param;
    return (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)("header", isHero && "header--hero", isBorderBottomNone && "header--border-none", className),
        role: "banner",
        children: children
    });
};
HeaderTag.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        prop_types.string,
        prop_types.elementType
    ]),
    isHero: prop_types.bool,
    isBorderBottomNone: prop_types.bool,
    children: prop_types.node.isRequired,
    className: prop_types.string
};
/* harmony default export */ var Tag = (HeaderTag);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/Container.js




const HeaderContainer = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
            px: true,
            className: "header__layout navbar",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                    middle: true,
                    justify: true,
                    children: children
                })
            })
        })
    });
};
HeaderContainer.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var Container = (HeaderContainer);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/ToggleButton.js
/* eslint-disable jsx-a11y/control-has-associated-label */ 



const NavbarToggleButton = (param)=>/*#__PURE__*/ {
    let { classNames , isOpen =false , onClick  } = param;
    return (0,jsx_runtime.jsxs)("button", {
        onClick: onClick,
        type: "button",
        className: (0,classes/* classes */.S)("navbar__toggle", isOpen && "expanded", classNames),
        "data-toggle": "toggleButton",
        "data-target": "#navbar",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "icon-bar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "icon-bar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "icon-bar"
            })
        ]
    });
};
NavbarToggleButton.propTypes = {
    classNames: prop_types.string,
    onClick: prop_types.func,
    isOpen: prop_types.bool
};
/* harmony default export */ var ToggleButton = (NavbarToggleButton);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Header/context.js
var context = __webpack_require__(3197);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/Toggle.js





const HeaderToggle = (param)=>{
    let { children , withToggle =true  } = param;
    const { isOpen , onToggle  } = (0,context/* useHeader */.g)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "navbar__header align-justify",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "header__logo",
                children: children
            }),
            withToggle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleButton, {
                onClick: onToggle,
                isOpen: isOpen
            })
        ]
    });
};
HeaderToggle.propTypes = {
    children: prop_types.node.isRequired,
    withToggle: prop_types.bool
};
/* harmony default export */ var Toggle = (HeaderToggle);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/Collapse.js





const HeaderCollapse = (param)=>{
    let { children  } = param;
    const { isOpen  } = (0,context/* useHeader */.g)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("navbar__collapse", isOpen && "show"),
        id: "navbar",
        children: children
    });
};
HeaderCollapse.propTypes = {
    children: prop_types.node.isRequired
};
/* harmony default export */ var Collapse = (HeaderCollapse);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/Header.js








const Header = (param)=>{
    let { hero =false , isBorderBottomNone =false , className ="" , logo , children , withToggle  } = param;
    const [isOpen, setOpen] = (0,react.useState)(false);
    const onOpen = (0,react.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    const onClose = (0,react.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const onToggle = (0,react.useCallback)(()=>{
        setOpen((state)=>!state);
    }, [
        setOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
        value: {
            isOpen,
            onToggle,
            onOpen,
            onClose
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
            isHero: hero,
            isBorderBottomNone: isBorderBottomNone,
            className: className,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle, {
                        withToggle: withToggle,
                        children: logo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse, {
                        children: children
                    })
                ]
            })
        })
    });
};
Header.propTypes = {
    hero: prop_types.bool,
    isBorderBottomNone: prop_types.bool,
    // inverted: bool,
    logo: prop_types.element.isRequired,
    children: prop_types.node,
    className: prop_types.string,
    withToggle: prop_types.bool
};
/* harmony default export */ var Header_Header = (Header);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Header/index.js



/***/ }),

/***/ 42866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Heading_Heading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/fontWeight.js
var fontWeight = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/Heading.js









const Heading = (param)=>{
    let { Tag ="h2" , size , color , weight , center , uppercase =false , className , italic , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    const isHeading = true;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)("heading", size && "heading-".concat(size), weight && fontWeight/* default */.Z[weight], center && "text-center", italic && "text-italic", uppercase && "text-uppercase", color && "text-color-".concat(color), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx, isHeading), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Heading.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        (0,prop_types.oneOf)([
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6"
        ]),
        prop_types.elementType
    ]),
    size: props_sx/* fontSizePropTypes */.Gk,
    center: prop_types.bool,
    italic: prop_types.bool,
    uppercase: prop_types.bool,
    weight: (0,prop_types.oneOf)(Object.keys(fontWeight/* default */.Z)),
    color: props_sx/* colorPropTypes */.AK,
    className: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    sx: props_sx/* sxPropTypes */.I1
};
/* harmony default export */ var Heading_Heading = ((0,pureFC/* default */.Z)(Heading));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js



/***/ }),

/***/ 10334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Image_Image; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/AssetsProvider/index.js + 1 modules
var AssetsProvider = __webpack_require__(84154);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sizing.js
var props_sizing = __webpack_require__(88270);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Image/Image.js









const Image = (param)=>{
    let { isBaseUrl =true , forwardRef , src , alt ="" , shadow =false , grayscale =false , invert , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sizing ={
        ...props_sizing/* sizingProps */.H6
    } , className ="" , ...props } = param;
    const ctxBaseUrl = (0,react.useContext)(AssetsProvider/* default.context */.Z.context);
    const baseUrl = isBaseUrl ? ctxBaseUrl : "";
    const altText = alt.trim();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        ref: forwardRef,
        className: (0,classes/* classes */.S)("image", shadow && "image--shadow", grayscale && "image--grayscale", invert && "image--invert-".concat(invert), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), ...(0,props_sizing/* sizingClassName */.rs)(sizing), className),
        alt: altText,
        ...props,
        src: "".concat(baseUrl).concat(src)
    });
};
Image.propTypes = {
    forwardRef: forward_ref/* default */.Z,
    isBaseUrl: prop_types.bool,
    src: prop_types.string.isRequired,
    className: prop_types.string,
    alt: prop_types.string,
    shadow: prop_types.bool,
    grayscale: prop_types.bool,
    invert: (0,prop_types.oneOf)([
        "white",
        "black"
    ]),
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    sizing: props_sizing/* sizingPropTypes */.bm
};
/* harmony default export */ var Image_Image = (Image);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js



/***/ }),

/***/ 71412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/Layout.js





const Header = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
Header.propTypes = {
    children: prop_types.node.isRequired
};
const Body = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
            role: "main",
            ...props
        })
    });
};
Body.propTypes = {
    ...Block/* default.propTypes */.Z.propTypes
};
const Footer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
Footer.propTypes = {
    children: prop_types.node.isRequired
};
const Layout = (param)=>/*#__PURE__*/ {
    let { bgColor ="transparent" , children , isWrapper =false , className =""  } = param;
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "body{background-color: ".concat(bgColor, "}")
            }),
            !isWrapper && !className ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,classes/* classes */.S)(isWrapper && "layout-wrapper", className),
                children: children
            })
        ]
    });
};
Layout.propTypes = {
    children: prop_types.node.isRequired,
    isWrapper: prop_types.bool,
    bgColor: prop_types.string,
    className: prop_types.string
};
Layout.Header = Header;
Layout.Body = Body;
Layout.Footer = Footer;
/* harmony default export */ var Layout_Layout = (Layout);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/index.js



/***/ }),

/***/ 25522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Link_Link; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/fontWeight.js
var fontWeight = __webpack_require__(36336);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Link/Link.js










const Link = (param)=>{
    let { Tag ="a" , isBaseClassName =true , external =false , size , weight , color , hoverColor , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className , ...props } = param;
    const sizeProps = size ? {
        fontSize: size
    } : {};
    const weightProps = weight ? {
        fontWeight: weight
    } : {};
    const defaultColorProps = color ? {
        fontColor: color
    } : {
        fontColor: null
    };
    const defaultColorHoverProps = hoverColor ? {
        fontColor: hoverColor
    } : {
        fontColor: null
    };
    const colorProps = {
        ...defaultColorProps,
        hover: {
            ...defaultColorHoverProps
        }
    };
    const classNameList = (0,react.useMemo)(()=>(0,classes/* classes */.S)(isBaseClassName && "link", external && "link--external", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)((0,pureProps/* deepMergeProps */.p)({
            ...sizeProps,
            ...weightProps,
            ...colorProps
        }, (0,pureProps/* default */.Z)(sx))), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className), [
        sizeProps,
        weightProps,
        colorProps
    ]);
    const classNameProp = classNameList ? {
        className: classNameList
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        ...props,
        ...classNameProp
    });
};
Link.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        (0,prop_types.oneOf)([
            "a",
            "button"
        ]),
        prop_types.elementType
    ]),
    isBaseClassName: prop_types.bool,
    external: prop_types.bool,
    size: (0,prop_types.oneOf)([
        "xxxl",
        "xxl",
        "xl",
        "l",
        "m",
        "s",
        "xs"
    ]),
    weight: (0,prop_types.oneOf)(Object.keys(fontWeight/* default */.Z)),
    color: props_sx/* colorPropTypes */.AK,
    hoverColor: props_sx/* colorPropTypes */.AK,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    className: prop_types.string
};
const LinkButton = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
        Tag: "button",
        type: "button",
        ...props
    });
Link.Button = LinkButton;
/* harmony default export */ var Link_Link = ((0,pureFC/* default */.Z)(Link));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js



/***/ }),

/***/ 46096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LogoLink_LogoLink; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/LogoLink/LogoLink.js






const LogoLink = (param)=>/*#__PURE__*/ {
    let { href ="/" , external =true , imgSrc , alt ="" , className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: href,
        external: external,
        isBaseClassName: false,
        className: (0,classes/* classes */.S)("logo-link", className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: imgSrc,
            className: (0,classes/* classes */.S)("logo"),
            alt: alt
        })
    });
};
LogoLink.propTypes = {
    href: prop_types.string,
    external: prop_types.bool,
    imgSrc: prop_types.string.isRequired,
    alt: prop_types.string,
    className: prop_types.string
};
/* harmony default export */ var LogoLink_LogoLink = (LogoLink);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/LogoLink/index.js



/***/ }),

/***/ 88270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H6": function() { return /* binding */ sizingProps; },
/* harmony export */   "bm": function() { return /* binding */ sizingPropTypes; },
/* harmony export */   "rs": function() { return /* binding */ sizingClassName; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

const additionalValues = [
    "auto",
    "full",
    "screen",
    "px"
];
const additionalMinValues = [
    "full",
    "screen"
];
const additionalMaxValues = [
    "full",
    "screen"
];
const values = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    64,
    65,
    66,
    67,
    68,
    69,
    70,
    71,
    72,
    73,
    74,
    75,
    76,
    77,
    78,
    79,
    80,
    81,
    82,
    83,
    84,
    85,
    86,
    87,
    88,
    89,
    90,
    91,
    92,
    93,
    94,
    95,
    96,
    97,
    98,
    99,
    100,
    101,
    102,
    103,
    104,
    105,
    106,
    107,
    108,
    109,
    110,
    111,
    112,
    113,
    114,
    115,
    116,
    117,
    118,
    119,
    120,
    121,
    122,
    123,
    124,
    125,
    126,
    127,
    128,
    129,
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    153,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164
];
const maskProps = {
    h: null,
    w: null,
    minH: null,
    minW: null,
    maxH: null,
    maxW: null
};
const maskPropTypes = {
    h: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)([
        ...additionalValues,
        ...values
    ]),
    w: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)([
        ...additionalValues,
        ...values
    ]),
    minH: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)([
        ...additionalMinValues,
        ...values
    ]),
    minW: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)([
        ...additionalMinValues,
        ...values
    ]),
    maxH: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)([
        ...additionalMaxValues,
        ...values
    ]),
    maxW: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)([
        ...additionalMaxValues,
        ...values
    ])
};
const sizingProps = {
    ...maskProps,
    sm: {
        ...maskProps
    },
    md: {
        ...maskProps
    },
    lg: {
        ...maskProps
    }
};
const sizingPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    ...maskPropTypes,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        ...maskPropTypes
    }),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        ...maskPropTypes
    }),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        ...maskPropTypes
    })
});
const checkValue = (value)=>values.indexOf(value) !== -1;
const checkAdditionalValues = (value)=>additionalValues.indexOf(value) !== -1;
const checkAdditionalMinValues = (value)=>additionalMinValues.indexOf(value) !== -1;
const checkAdditionalMaxValues = (value)=>additionalMaxValues.indexOf(value) !== -1;
const responsiveCheckValues = function(h, w, minH, minW, maxH, maxW) {
    let media = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, mediaName = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "";
    if (media) {
        return [
            (checkValue(media.h) || checkAdditionalValues(media.h)) && "h-".concat(media.h, "--").concat(mediaName),
            (checkValue(media.w) || checkAdditionalValues(media.w)) && "w-".concat(media.w, "--").concat(mediaName),
            media.minH && (checkValue(media.minH) || checkAdditionalMinValues(media.minH)) && "min-h-".concat(media.minH, "--").concat(mediaName),
            media.minW && (checkValue(media.minW) || checkAdditionalMinValues(media.minW)) && "min-w-".concat(media.minW, "--").concat(mediaName),
            media.maxH && (checkValue(media.maxH) || checkAdditionalMaxValues(media.maxH)) && "max-h-".concat(media.maxH, "--").concat(mediaName),
            media.maxW && (checkValue(media.maxW) || checkAdditionalMaxValues(media.maxW)) && "max-w-".concat(media.maxW, "--").concat(mediaName)
        ];
    }
    return [
        (checkValue(w) || checkAdditionalValues(w)) && "w-".concat(w),
        (checkValue(h) || checkAdditionalValues(h)) && "h-".concat(h),
        (checkValue(minH) || checkAdditionalMinValues(minH)) && "min-h-".concat(minH),
        (checkValue(minW) || checkAdditionalMinValues(minW)) && "min-w-".concat(minW),
        (checkValue(maxH) || checkAdditionalMaxValues(maxH)) && "max-h-".concat(maxH),
        (checkValue(maxW) || checkAdditionalMaxValues(maxW)) && "max-w-".concat(maxW)
    ];
};
// TODO: can be expanded if needed (min-w / max-w / min-h / max-w)
const sizingClassName = (param)=>{
    let { h , w , minH , minW , maxH , maxW , sm , md , lg  } = param;
    const sizingClass = [
        ...responsiveCheckValues(h, w, minH, minW, maxH, maxW),
        ...responsiveCheckValues(h, w, minH, minW, maxH, maxW, sm, "sm"),
        ...responsiveCheckValues(h, w, minH, minW, maxH, maxW, md, "md"),
        ...responsiveCheckValues(h, w, minH, minW, maxH, maxW, lg, "lg")
    ];
    return sizingClass.filter(Boolean);
};


/***/ }),

/***/ 2349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RB": function() { return /* binding */ spacingClassName; },
/* harmony export */   "Xj": function() { return /* binding */ spacingPropTypes; },
/* harmony export */   "tF": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

const values = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    64,
    "auto",
    "m1",
    "m2",
    "m3",
    "m4",
    "m5",
    "m6",
    "m7",
    "m8",
    "m9",
    "m10",
    "m11",
    "m12",
    "m13",
    "m14",
    "m15",
    "m16",
    "m17",
    "m18",
    "m19",
    "m20",
    "m21",
    "m22",
    "m23",
    "m24",
    "m25",
    "m26",
    "m27",
    "m28",
    "m29",
    "m30",
    "m31",
    "m32",
    "m33",
    "m34",
    "m35",
    "m36",
    "m37",
    "m38",
    "m39",
    "m40",
    "m41",
    "m42",
    "m43",
    "m44",
    "m45",
    "m46",
    "m47",
    "m48",
    "m49",
    "m50",
    "m51",
    "m52",
    "m53",
    "m54",
    "m55",
    "m56",
    "m57",
    "m58",
    "m59",
    "m60",
    "m61",
    "m62",
    "m63",
    "m64"
];
const maskProps = {
    m: null,
    mr: null,
    ml: null,
    mt: null,
    mb: null,
    mx: null,
    my: null,
    p: null,
    pr: null,
    pl: null,
    pt: null,
    pb: null,
    px: null,
    py: null
};
const maskPropTypes = {
    m: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    mr: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    ml: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    mt: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    mb: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    mx: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    my: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    p: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    pr: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    pl: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    pt: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    pb: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    px: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values),
    py: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOf)(values)
};
const spacingProps = {
    ...maskProps,
    sm: {
        ...maskProps
    },
    md: {
        ...maskProps
    },
    lg: {
        ...maskProps
    }
};
const spacingPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    ...maskPropTypes,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        ...maskPropTypes
    }),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        ...maskPropTypes
    }),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        ...maskPropTypes
    })
});
const checkValue = (value)=>values.indexOf(value) !== -1;
const spacingClassName = (param)=>{
    let { ...props } = param;
    const { sm , md , lg , m , mr , ml , mt , mb , mx , my , p , pr , pl , pt , pb , px , py  } = props;
    // TODO: refactor to make code more concise
    return [
        checkValue(m) && "m-".concat(m),
        checkValue(mr) && "mr-".concat(mr),
        checkValue(ml) && "ml-".concat(ml),
        checkValue(mt) && "mt-".concat(mt),
        checkValue(mb) && "mb-".concat(mb),
        checkValue(mx) && "mx-".concat(mx),
        checkValue(my) && "my-".concat(my),
        checkValue(p) && "p-".concat(p),
        checkValue(pr) && "pr-".concat(pr),
        checkValue(pl) && "pl-".concat(pl),
        checkValue(pt) && "pt-".concat(pt),
        checkValue(pb) && "pb-".concat(pb),
        checkValue(px) && "px-".concat(px),
        checkValue(py) && "py-".concat(py),
        sm && checkValue(sm.m) && "m-".concat(sm.m, "--sm"),
        sm && checkValue(sm.mr) && "mr-".concat(sm.mr, "--sm"),
        sm && checkValue(sm.ml) && "ml-".concat(sm.ml, "--sm"),
        sm && checkValue(sm.mt) && "mt-".concat(sm.mt, "--sm"),
        sm && checkValue(sm.mb) && "mb-".concat(sm.mb, "--sm"),
        sm && checkValue(sm.mx) && "mx-".concat(sm.mx, "--sm"),
        sm && checkValue(sm.my) && "my-".concat(sm.my, "--sm"),
        sm && checkValue(sm.p) && "p-".concat(sm.p, "--sm"),
        sm && checkValue(sm.pr) && "pr-".concat(sm.pr, "--sm"),
        sm && checkValue(sm.pl) && "pl-".concat(sm.pl, "--sm"),
        sm && checkValue(sm.pt) && "pt-".concat(sm.pt, "--sm"),
        sm && checkValue(sm.pb) && "pb-".concat(sm.pb, "--sm"),
        sm && checkValue(sm.px) && "px-".concat(sm.px, "--sm"),
        sm && checkValue(sm.py) && "py-".concat(sm.py, "--sm"),
        md && checkValue(md.m) && "m-".concat(md.m, "--md"),
        md && checkValue(md.mr) && "mr-".concat(md.mr, "--md"),
        md && checkValue(md.ml) && "ml-".concat(md.ml, "--md"),
        md && checkValue(md.mt) && "mt-".concat(md.mt, "--md"),
        md && checkValue(md.mb) && "mb-".concat(md.mb, "--md"),
        md && checkValue(md.mx) && "mx-".concat(md.mx, "--md"),
        md && checkValue(md.my) && "my-".concat(md.my, "--md"),
        md && checkValue(md.p) && "p-".concat(md.p, "--md"),
        md && checkValue(md.pr) && "pr-".concat(md.pr, "--md"),
        md && checkValue(md.pl) && "pl-".concat(md.pl, "--md"),
        md && checkValue(md.pt) && "pt-".concat(md.pt, "--md"),
        md && checkValue(md.pb) && "pb-".concat(md.pb, "--md"),
        md && checkValue(md.px) && "px-".concat(md.px, "--md"),
        md && checkValue(md.py) && "py-".concat(md.py, "--md"),
        lg && checkValue(lg.m) && "m-".concat(lg.m, "--lg"),
        lg && checkValue(lg.mr) && "mr-".concat(lg.mr, "--lg"),
        lg && checkValue(lg.ml) && "ml-".concat(lg.ml, "--lg"),
        lg && checkValue(lg.mt) && "mt-".concat(lg.mt, "--lg"),
        lg && checkValue(lg.mb) && "mb-".concat(lg.mb, "--lg"),
        lg && checkValue(lg.mx) && "mx-".concat(lg.mx, "--lg"),
        lg && checkValue(lg.my) && "my-".concat(lg.my, "--lg"),
        lg && checkValue(lg.p) && "p-".concat(lg.p, "--lg"),
        lg && checkValue(lg.pr) && "pr-".concat(lg.pr, "--lg"),
        lg && checkValue(lg.pl) && "pl-".concat(lg.pl, "--lg"),
        lg && checkValue(lg.pt) && "pt-".concat(lg.pt, "--lg"),
        lg && checkValue(lg.pb) && "pb-".concat(lg.pb, "--lg"),
        lg && checkValue(lg.px) && "px-".concat(lg.px, "--lg"),
        lg && checkValue(lg.py) && "py-".concat(lg.py, "--lg")
    ];
};


/***/ }),

/***/ 23720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AK": function() { return /* binding */ colorPropTypes; },
/* harmony export */   "ET": function() { return /* binding */ sxProps; },
/* harmony export */   "Gk": function() { return /* binding */ fontSizePropTypes; },
/* harmony export */   "I1": function() { return /* binding */ sxPropTypes; },
/* harmony export */   "ZA": function() { return /* binding */ sxClassName; },
/* harmony export */   "g4": function() { return /* binding */ textAlignPropTypes; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68657);


const fontSizePropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    "xs",
    "s",
    "m",
    "l",
    "xl",
    "xxl",
    "xxxl"
]);
const colorPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    ..._utils_color__WEBPACK_IMPORTED_MODULE_0__/* .brandColors */ .D2,
    ..._utils_color__WEBPACK_IMPORTED_MODULE_0__/* .blackColors */ .qr,
    ..._utils_color__WEBPACK_IMPORTED_MODULE_0__/* .whiteColors */ .cK,
    ..._utils_color__WEBPACK_IMPORTED_MODULE_0__/* .commonColors */ .Hk
]);
const textAlignPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    "left",
    "center",
    "right"
]);
const textDecorationPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    "underline"
]);
const textTransformPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    "uppercase",
    "capitalize"
]);
const fontWeightPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900,
    "thin",
    "ultra-light",
    "light",
    "normal",
    "medium",
    "semi",
    "bold",
    "extra",
    "heavy"
]);
const sxProps = {
    textAlign: null,
    textTransform: null,
    textEllipsis: null,
    fontSize: null,
    fontColor: null,
    fontWeight: null,
    fontStyle: null,
    hover: {
        fontColor: null
    },
    sm: {
        textAlign: null
    },
    md: {
        textAlign: null
    },
    lg: {
        textAlign: null
    }
};
const sxPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
    textAlign: textAlignPropTypes,
    textTransform: textTransformPropTypes,
    textEllipsis: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
    fontSize: fontSizePropTypes,
    fontColor: colorPropTypes,
    textDecoration: textDecorationPropTypes,
    fontWeight: fontWeightPropTypes,
    fontStyle: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        "italic"
    ]),
    hover: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
        fontColor: colorPropTypes,
        textDecoration: textDecorationPropTypes
    }),
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
        textAlign: textAlignPropTypes
    }),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
        textAlign: textAlignPropTypes
    }),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
        textAlign: textAlignPropTypes
    })
});
const sxClassName = function(param) {
    let { ...props } = param, isHeading = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { textAlign , textTransform , textEllipsis , fontSize , fontColor , textDecoration , fontWeight , fontStyle , hover , sm , md , lg  } = props;
    return [
        fontSize && (isHeading ? "heading-".concat(fontSize) : "text-".concat(fontSize)),
        fontColor && "text-color-".concat(fontColor),
        hover && hover.fontColor && "text-color-".concat(hover.fontColor, "--hover"),
        fontWeight && "text-weight--".concat(fontWeight),
        fontStyle && "text-".concat(fontStyle),
        textAlign && "text-".concat(textAlign),
        textDecoration && "text-decoration--".concat(textDecoration),
        hover && hover.textDecoration && "text-decoration--".concat(hover.textDecoration, "--hover"),
        textTransform && "text-".concat(textTransform),
        textEllipsis && "text-ellipsis",
        sm && sm.textAlign && "small-text-".concat(sm.textAlign),
        md && md.textAlign && "medium-text-".concat(md.textAlign),
        lg && lg.textAlign && "large-text-".concat(lg.textAlign)
    ];
};


/***/ }),

/***/ 18981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": function() { return /* binding */ utilityProps; },
/* harmony export */   "b2": function() { return /* binding */ utilityClassName; },
/* harmony export */   "pQ": function() { return /* binding */ utilityPropTypes; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7820);
/* harmony import */ var _sx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23720);



const utilityProps = {
    opacity: null,
    border: null,
    display: null,
    justify: null,
    align: {
        self: null,
        items: null,
        content: null
    },
    offset: null,
    order: null,
    radius: null,
    bgColor: null,
    shadow: null,
    overflow: null,
    position: null,
    sm: {
        opacity: null,
        border: null,
        radius: null,
        display: null,
        justify: null,
        align: {
            self: null,
            items: null,
            content: null
        },
        offset: null,
        order: null
    },
    md: {
        opacity: null,
        border: null,
        radius: null,
        display: null,
        justify: null,
        align: {
            self: null,
            items: null,
            content: null
        },
        offset: null,
        order: null
    },
    lg: {
        opacity: null,
        border: null,
        radius: null,
        display: null,
        justify: null,
        align: {
            self: null,
            items: null,
            content: null
        },
        offset: null,
        order: null
    }
};
const borderRadiusTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    "50p"
]);
const borderPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
    width: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        0,
        1,
        2,
        3,
        4
    ]),
    color: _sx__WEBPACK_IMPORTED_MODULE_0__/* .colorPropTypes */ .AK
});
const positionPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
    position: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        "relative",
        "absolute",
        "fixed",
        "sticky"
    ]),
    top: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
    ]),
    bottom: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
    ]),
    left: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
    ]),
    right: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
    ])
});
const adaptivePropTypes = {
    border: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType)([
        (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
            top: borderPropTypes,
            right: borderPropTypes,
            bottom: borderPropTypes,
            left: borderPropTypes
        }),
        borderPropTypes
    ]),
    radius: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType)([
        (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
            topLeft: borderRadiusTypes,
            topRight: borderRadiusTypes,
            bottomRight: borderRadiusTypes,
            bottomLeft: borderRadiusTypes
        }),
        borderRadiusTypes
    ]),
    display: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        "none",
        "block",
        "inline-block",
        "flex",
        "flex-vertical"
    ]),
    justify: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        "start",
        "end",
        "center",
        "between",
        "around",
        "evenly"
    ]),
    align: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
        items: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
            "start",
            "end",
            "center",
            "baseline",
            "stretch"
        ]),
        self: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
            "start",
            "end",
            "center",
            "baseline",
            "stretch"
        ]),
        content: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
            "start",
            "end",
            "center",
            "between",
            "around",
            "stretch"
        ])
    }),
    offset: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    order: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        1,
        2,
        3,
        4,
        5,
        6
    ]),
    opacity: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        0,
        50,
        100
    ])
};
const utilityPropTypes = (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)({
    bgColor: _sx__WEBPACK_IMPORTED_MODULE_0__/* .colorPropTypes */ .AK,
    shadow: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_1__.bool
    ]),
    overflow: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOf)([
        "hidden",
        "scrollX",
        "scrollY"
    ]),
    position: positionPropTypes,
    ...adaptivePropTypes,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)(adaptivePropTypes),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)(adaptivePropTypes),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.shape)(adaptivePropTypes)
});
const utilityClassName = (param)=>{
    let { ...props } = param;
    const { radius , border , bgColor , shadow , overflow , display , justify , align , offset , order , opacity , sm , md , lg  } = props;
    const borderRadiusClassNames = function(borderRadiusProps) {
        let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        const isNumber = (value)=>typeof value === "number" && value >= 0;
        const is50 = (value)=>typeof value === "string" && value === "50p";
        const mediaSize = size ? "--".concat(size) : "";
        if (borderRadiusProps && !is50(borderRadiusProps) || isNumber(borderRadiusProps) || is50(borderRadiusProps)) {
            if (is50(borderRadiusProps) || Object.keys(borderRadiusProps).length === 0) {
                // eslint-disable-next-line no-nested-ternary
                return isNumber(borderRadiusProps) ? [
                    "border-radius-".concat(borderRadiusProps, "px").concat(mediaSize)
                ] : is50(borderRadiusProps) ? [
                    "border-radius-".concat(borderRadiusProps).concat(mediaSize)
                ] : [];
            }
            const pureBorderRadiusProps = (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(borderRadiusProps);
            return Object.keys(pureBorderRadiusProps).map((key)=>{
                const value = pureBorderRadiusProps[key];
                return isNumber(value) ? "border-radius-".concat(key.split(/(?=[A-Z])/).join("-").toLowerCase(), "-").concat(value, "px").concat(mediaSize) : "";
            });
        }
        return [];
    };
    const borderClassNames = function() {
        let borderProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        const borderClassNameTemplate = function(width, color, mediaSize) {
            let key = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
            const keyValue = key ? "-".concat(key) : "";
            const widthValue = width === 0 ? "none" : "".concat(width, "px");
            const colorValue = color ? "-".concat(color) : "";
            const mediaSizeValue = mediaSize ? "--".concat(mediaSize) : "";
            return "border".concat(keyValue, "-").concat(widthValue).concat(colorValue).concat(mediaSizeValue);
        };
        if (borderProps) {
            const sideProps = borderProps.top || borderProps.right || borderProps.bottom || borderProps.left || {};
            if (Object.keys(sideProps).length === 0) {
                const { width , color =null  } = borderProps;
                return typeof width !== "undefined" && width >= 0 ? [
                    borderClassNameTemplate(width, color, size)
                ] : [];
            }
            const pureBorderProps = (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(borderProps);
            return Object.keys(pureBorderProps).map((key)=>{
                const { width , color =null  } = pureBorderProps[key];
                return typeof width !== "undefined" && width >= 0 ? borderClassNameTemplate(width, color, size, key) : "";
            });
        }
        return [];
    };
    const PREFIX_CLASS_BG_COLOR = "bg-color-";
    const PREFIX_CLASS_BOX_SHADOW = "box-shadow";
    const PREFIX_CLASS_DISPLAY = "display-";
    const PREFIX_CLASS_OVERFLOW = "overflow--";
    const PREFIX_CLASS_JUSTIFY = "justify-content-";
    const PREFIX_CLASS_ALIGN = "align-";
    const PREFIX_CLASS_OFFSET = "offset-";
    const PREFIX_CLASS_ORDER = "order-";
    return [
        ...borderClassNames(border),
        ...borderRadiusClassNames(radius),
        bgColor && "".concat(PREFIX_CLASS_BG_COLOR).concat(bgColor),
        shadow && PREFIX_CLASS_BOX_SHADOW,
        overflow && "".concat(PREFIX_CLASS_OVERFLOW).concat(overflow),
        display && "".concat(PREFIX_CLASS_DISPLAY).concat(display),
        justify && "".concat(PREFIX_CLASS_JUSTIFY).concat(justify),
        align && align.self && "".concat(PREFIX_CLASS_ALIGN, "self-").concat(align.self),
        align && align.items && "".concat(PREFIX_CLASS_ALIGN, "items-").concat(align.items),
        align && align.content && "".concat(PREFIX_CLASS_ALIGN, "content-").concat(align.content),
        offset && "".concat(PREFIX_CLASS_OFFSET).concat(offset),
        order && "".concat(PREFIX_CLASS_ORDER).concat(order),
        opacity && "opacity-".concat(opacity),
        ...borderClassNames(sm && sm.border, "sm"),
        ...borderRadiusClassNames(sm && sm.radius, "sm"),
        sm && sm.display && "".concat(PREFIX_CLASS_DISPLAY).concat(sm.display, "--sm"),
        sm && sm.overflow && "".concat(PREFIX_CLASS_OVERFLOW).concat(sm.overflow, "--sm"),
        sm && sm.justify && "".concat(PREFIX_CLASS_JUSTIFY).concat(sm.justify, "--sm"),
        sm && sm.align && sm.align.self && "".concat(PREFIX_CLASS_ALIGN, "self-").concat(sm.align.self, "--sm"),
        sm && sm.align && sm.align.items && "".concat(PREFIX_CLASS_ALIGN, "items-").concat(sm.align.items, "--sm"),
        sm && sm.align && sm.align.content && "".concat(PREFIX_CLASS_ALIGN, "content-").concat(sm.align.content, "--sm"),
        sm && sm.offset && "".concat(PREFIX_CLASS_OFFSET).concat(sm.offset, "--sm"),
        sm && sm.order && "".concat(PREFIX_CLASS_ORDER).concat(sm.order, "--sm"),
        sm && sm.opacity && "opacity-".concat(sm.opacity, "--sm"),
        ...borderClassNames(md && md.border, "md"),
        ...borderRadiusClassNames(md && md.radius, "md"),
        md && md.display && "".concat(PREFIX_CLASS_DISPLAY).concat(md.display, "--md"),
        md && md.overflow && "".concat(PREFIX_CLASS_OVERFLOW).concat(md.overflow, "--md"),
        md && md.justify && "".concat(PREFIX_CLASS_JUSTIFY).concat(md.justify, "--md"),
        md && md.align && md.align.self && "".concat(PREFIX_CLASS_ALIGN, "self-").concat(md.align.self, "--md"),
        md && md.align && md.align.items && "".concat(PREFIX_CLASS_ALIGN, "items-").concat(md.align.items, "--md"),
        md && md.align && md.align.content && "".concat(PREFIX_CLASS_ALIGN, "content-").concat(md.align.content, "--md"),
        md && md.offset && "".concat(PREFIX_CLASS_OFFSET).concat(md.offset, "--md"),
        md && md.order && "".concat(PREFIX_CLASS_ORDER).concat(md.order, "--md"),
        md && md.opacity && "opacity-".concat(md.opacity, "--md"),
        ...borderClassNames(lg && lg.border, "lg"),
        ...borderRadiusClassNames(lg && lg.radius, "lg"),
        lg && lg.display && "".concat(PREFIX_CLASS_DISPLAY).concat(lg.display, "--lg"),
        lg && lg.overflow && "".concat(PREFIX_CLASS_OVERFLOW).concat(lg.overflow, "--lg"),
        lg && lg.justify && "".concat(PREFIX_CLASS_JUSTIFY).concat(lg.justify, "--lg"),
        lg && lg.align && lg.align.self && "".concat(PREFIX_CLASS_ALIGN, "self-").concat(lg.align.self, "--lg"),
        lg && lg.align && lg.align.items && "".concat(PREFIX_CLASS_ALIGN, "items-").concat(lg.align.items, "--lg"),
        lg && lg.align && lg.align.content && "".concat(PREFIX_CLASS_ALIGN, "content-").concat(lg.align.content, "--lg"),
        lg && lg.offset && "".concat(PREFIX_CLASS_OFFSET).concat(lg.offset, "--lg"),
        lg && lg.order && "".concat(PREFIX_CLASS_ORDER).concat(lg.order, "--lg"),
        lg && lg.opacity && "opacity-".concat(lg.opacity, "--lg")
    ];
};


/***/ }),

/***/ 67924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ classes; }
/* harmony export */ });
/* unused harmony export cn */
/* harmony import */ var _insightfulscience_shared_utils_lib_fn_pipe__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38733);
/* harmony import */ var _transduce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70627);
/* harmony import */ var _predicates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53863);
/* eslint-disable prettier/prettier */ 


const trim = (value)=>value.trim();
const cn = (className)=>isString(className) ? trim(className) : "";
const join = function() {
    let separator = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return (text, str)=>text && str && "".concat(text).concat(separator).concat(str) || str || text;
};
const classes = function() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++){
        classNames[_key] = arguments[_key];
    }
    return classNames.reduce((0,_insightfulscience_shared_utils_lib_fn_pipe__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(join(" "), _transduce__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hX((0,_predicates__WEBPACK_IMPORTED_MODULE_2__/* .isUnique */ .bT)()), _transduce__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hX(_predicates__WEBPACK_IMPORTED_MODULE_2__/* .isNotEmpty */ .UE), _transduce__WEBPACK_IMPORTED_MODULE_1__/* .map */ .UI(trim), _transduce__WEBPACK_IMPORTED_MODULE_1__/* .filter */ .hX(_predicates__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .HD)), "");
};


/***/ }),

/***/ 68657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A2": function() { return /* binding */ colorWhite; },
/* harmony export */   "D2": function() { return /* binding */ brandColors; },
/* harmony export */   "Hk": function() { return /* binding */ commonColors; },
/* harmony export */   "ZH": function() { return /* binding */ bgColorBlack; },
/* harmony export */   "cK": function() { return /* binding */ whiteColors; },
/* harmony export */   "qr": function() { return /* binding */ blackColors; },
/* harmony export */   "vk": function() { return /* binding */ bgColorBlack2; }
/* harmony export */ });
/* unused harmony exports bgBrandGradient, bgColorNone, bgColorBlack85, bgColorBlack64, bgColorBlack60, bgColorBlack46, bgColorBlack40, bgColorBlack35, bgColorBlack20, bgColorBlack15, bgColorBlack10, bgColorBlack4, bgColorBlackCustom1, bgColorBlackCustom2, bgColorWhite, bgColorWhite80, bgColorWhite70, bgColorWhite60, bgColorWhite40, bgColorWhite35, bgColorWhite20, bgColorWhite15, bgColorWhite10, bgColorWhite4, bgColor1, bgColor114, bgColor110, bgColor105, bgColor1l, bgColor2, bgColor210, bgColor205, bgColor286, bgColor3, bgColor360, bgColor310, bgColor305, bgColor4, bgColor414, bgColor405, bgColor5, bgColor540, bgColor512, bgColor503, bgColor6, bgColorGreen, bgColorRed, bgColorLime, bgColorOrange, colorBlack, colorBlack85, colorBlack64, colorBlack60, colorBlack46, colorBlack40, colorBlack35, colorBlack20, colorBlack15, colorBlack10, colorBlack4, colorBlack2, colorWhite80, colorWhite70, colorWhite60, colorWhite40, colorWhite35, colorWhite20, colorWhite15, colorWhite10, colorWhite4, color1, color114, color110, color105, color1l, color2, color210, color205, color286, color3, color360, color310, color305, color4, color414, color405, color5, color540, color512, color503, colorGreen, colorRed, colorLime, colorOrange */
const bgTpl = (color)=>"bg-color-".concat(color);
const colorTpl = (color)=>"text-color-".concat(color);
const commonColorsSchema = {
    none: "none",
    transparent: "transparent",
    inherit: "inherit",
    red: "red",
    green: "green",
    lime: "lime",
    orange: "orange",
    "dotmatics-1": "dotmatics-1",
    "dotmatics-2": "dotmatics-2",
    "dotmatics-3": "dotmatics-3",
    "dotmatics-4": "dotmatics-4",
    "dotmatics-5": "dotmatics-5",
    "dotmatics-6": "dotmatics-6"
};
const blackColorSchema = {
    100: "black",
    85: "black--85",
    64: "black--64",
    60: "black--60",
    46: "black--46",
    40: "black--40",
    35: "black--35",
    20: "black--20",
    15: "black--15",
    10: "black--10",
    4: "black--04",
    2: "black--02",
    "custom-1": "black--custom-1",
    "custom-2": "black--custom-2"
};
const whiteColorSchema = {
    100: "white",
    80: "white--80",
    70: "white--70",
    60: "white--60",
    40: "white--40",
    35: "white--35",
    20: "white--20",
    15: "white--15",
    10: "white--10",
    4: "white--04"
};
const brandColorSchema = {
    100: "1",
    114: "1--14",
    110: "1--10",
    105: "1--05",
    "1l": "1--light",
    200: "2",
    210: "2--10",
    205: "2--05",
    240: "2--40",
    250: "2--50",
    260: "2--60",
    270: "2--70",
    "2c1": "2--custom-1",
    "2c2": "2--custom-2",
    300: "3",
    360: "3--60",
    310: "3--10",
    305: "3--05",
    400: "4",
    414: "4--14",
    405: "4--05",
    500: "5",
    540: "5--40",
    512: "5--12",
    503: "5--03",
    600: "6",
    620: "6--20",
    630: "6--30",
    650: "6--50",
    670: "6--70",
    "brand-gradient": "brand-gradient"
};
const blackColors = Object.values(blackColorSchema);
const whiteColors = Object.values(whiteColorSchema);
const brandColors = Object.values(brandColorSchema);
const commonColors = Object.values(commonColorsSchema);
const bgBrandGradient = bgTpl(brandColorSchema["brand-gradient"]);
const bgColorNone = "bg--transparent";
const bgColorBlack = bgTpl(blackColorSchema["100"]);
const bgColorBlack85 = bgTpl(blackColorSchema["85"]);
const bgColorBlack64 = bgTpl(blackColorSchema["64"]);
const bgColorBlack60 = bgTpl(blackColorSchema["60"]);
const bgColorBlack46 = bgTpl(blackColorSchema["46"]);
const bgColorBlack40 = bgTpl(blackColorSchema["40"]);
const bgColorBlack35 = bgTpl(blackColorSchema["35"]);
const bgColorBlack20 = bgTpl(blackColorSchema["20"]);
const bgColorBlack15 = bgTpl(blackColorSchema["15"]);
const bgColorBlack10 = bgTpl(blackColorSchema["10"]);
const bgColorBlack4 = bgTpl(blackColorSchema["4"]);
const bgColorBlack2 = bgTpl(blackColorSchema["2"]);
const bgColorBlackCustom1 = bgTpl(blackColorSchema["custom-1"]);
const bgColorBlackCustom2 = bgTpl(blackColorSchema["custom-2"]);
const bgColorWhite = bgTpl(whiteColorSchema["100"]);
const bgColorWhite80 = bgTpl(whiteColorSchema["80"]);
const bgColorWhite70 = bgTpl(whiteColorSchema["70"]);
const bgColorWhite60 = bgTpl(whiteColorSchema["60"]);
const bgColorWhite40 = bgTpl(whiteColorSchema["40"]);
const bgColorWhite35 = bgTpl(whiteColorSchema["35"]);
const bgColorWhite20 = bgTpl(whiteColorSchema["20"]);
const bgColorWhite15 = bgTpl(whiteColorSchema["15"]);
const bgColorWhite10 = bgTpl(whiteColorSchema["10"]);
const bgColorWhite4 = bgTpl(whiteColorSchema["4"]);
const bgColor1 = bgTpl(brandColorSchema["100"]);
const bgColor114 = bgTpl(brandColorSchema["114"]);
const bgColor110 = bgTpl(brandColorSchema["110"]);
const bgColor105 = bgTpl(brandColorSchema["105"]);
const bgColor1l = bgTpl(brandColorSchema["1l"]);
const bgColor2 = bgTpl(brandColorSchema["200"]);
const bgColor210 = bgTpl(brandColorSchema["210"]);
const bgColor205 = bgTpl(brandColorSchema["205"]);
const bgColor286 = bgTpl(brandColorSchema["286"]);
const bgColor3 = bgTpl(brandColorSchema["300"]);
const bgColor360 = bgTpl(brandColorSchema["360"]);
const bgColor310 = bgTpl(brandColorSchema["310"]);
const bgColor305 = bgTpl(brandColorSchema["305"]);
const bgColor4 = bgTpl(brandColorSchema["400"]);
const bgColor414 = bgTpl(brandColorSchema["414"]);
const bgColor405 = bgTpl(brandColorSchema["405"]);
const bgColor5 = bgTpl(brandColorSchema["500"]);
const bgColor540 = bgTpl(brandColorSchema["540"]);
const bgColor512 = bgTpl(brandColorSchema["512"]);
const bgColor503 = bgTpl(brandColorSchema["503"]);
const bgColor6 = bgTpl(brandColorSchema["600"]);
const bgColorGreen = bgTpl(commonColorsSchema.green);
const bgColorRed = bgTpl(commonColorsSchema.red);
const bgColorLime = bgTpl(commonColorsSchema.lime);
const bgColorOrange = bgTpl(commonColorsSchema.orange);
const colorBlack = colorTpl(blackColorSchema["100"]);
const colorBlack85 = colorTpl(blackColorSchema["85"]);
const colorBlack64 = colorTpl(blackColorSchema["64"]);
const colorBlack60 = colorTpl(blackColorSchema["60"]);
const colorBlack46 = colorTpl(blackColorSchema["46"]);
const colorBlack40 = colorTpl(blackColorSchema["40"]);
const colorBlack35 = colorTpl(blackColorSchema["35"]);
const colorBlack20 = colorTpl(blackColorSchema["20"]);
const colorBlack15 = colorTpl(blackColorSchema["15"]);
const colorBlack10 = colorTpl(blackColorSchema["10"]);
const colorBlack4 = colorTpl(blackColorSchema["4"]);
const colorBlack2 = colorTpl(blackColorSchema["2"]);
const colorWhite = colorTpl(whiteColorSchema["100"]);
const colorWhite80 = colorTpl(whiteColorSchema["80"]);
const colorWhite70 = colorTpl(whiteColorSchema["70"]);
const colorWhite60 = colorTpl(whiteColorSchema["60"]);
const colorWhite40 = colorTpl(whiteColorSchema["40"]);
const colorWhite35 = colorTpl(whiteColorSchema["35"]);
const colorWhite20 = colorTpl(whiteColorSchema["20"]);
const colorWhite15 = colorTpl(whiteColorSchema["15"]);
const colorWhite10 = colorTpl(whiteColorSchema["10"]);
const colorWhite4 = colorTpl(whiteColorSchema["4"]);
const color1 = colorTpl(brandColorSchema["100"]);
const color114 = colorTpl(brandColorSchema["114"]);
const color110 = colorTpl(brandColorSchema["110"]);
const color105 = colorTpl(brandColorSchema["105"]);
const color1l = colorTpl(brandColorSchema["1l"]);
const color2 = colorTpl(brandColorSchema["200"]);
const color210 = colorTpl(brandColorSchema["210"]);
const color205 = colorTpl(brandColorSchema["205"]);
const color286 = colorTpl(brandColorSchema["286"]);
const color3 = colorTpl(brandColorSchema["300"]);
const color360 = colorTpl(brandColorSchema["360"]);
const color310 = colorTpl(brandColorSchema["310"]);
const color305 = colorTpl(brandColorSchema["305"]);
const color4 = colorTpl(brandColorSchema["400"]);
const color414 = colorTpl(brandColorSchema["414"]);
const color405 = colorTpl(brandColorSchema["405"]);
const color5 = colorTpl(brandColorSchema["500"]);
const color540 = colorTpl(brandColorSchema["540"]);
const color512 = colorTpl(brandColorSchema["512"]);
const color503 = colorTpl(brandColorSchema["503"]);
const colorGreen = bgTpl(commonColorsSchema.green);
const colorRed = bgTpl(commonColorsSchema.red);
const colorLime = bgTpl(commonColorsSchema.lime);
const colorOrange = bgTpl(commonColorsSchema.orange);


/***/ }),

/***/ 46393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bd": function() { return /* binding */ callIf; },
/* harmony export */   "qC": function() { return /* binding */ compose; },
/* harmony export */   "zl": function() { return /* binding */ ifDeff; }
/* harmony export */ });
/* unused harmony exports idX, pipe, mapValues, safeCall */
const idX = (argument)=>argument;
const compose2 = (f, g)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return f(g(...args));
    };
const compose = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return fns.length > 0 ? fns.reduce(compose2) : idX;
};
const pipe2 = (f, g)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return g(f(...args));
    };
const pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return fns.length > 0 ? fns.reduce(pipe2) : idX;
};
const mapValues = (mapper)=>(obj)=>Object.assign(...Object.entries(obj).map((param)=>{
            let [key, value] = param;
            return {
                [key]: mapper(value, key, obj)
            };
        }));
const safeCall = (fn, args)=>typeof fn === "function" ? fn(...args) : undefined;
const callIf = (predicate, thenFn, elseFn)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return safeCall(predicate(...args) ? thenFn : elseFn, args);
    };
const ifDeff = (value, def)=>value !== undefined ? value : def;


/***/ }),

/***/ 36336:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    thin: "text-weight--thin",
    "ultra-light": "text-weight--ultra-light",
    light: "text-weight--light",
    normal: "text-weight--normal",
    medium: "text-weight--medium",
    semi: "text-weight--semi",
    bold: "text-weight--bold",
    extra: "text-weight--extra",
    heavy: "text-weight--heavy"
});


/***/ }),

/***/ 52418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

// eslint-disable-next-line react/forbid-prop-types
const forwardRef = (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.oneOfType)([
    prop_types__WEBPACK_IMPORTED_MODULE_0__.func,
    (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        current: prop_types__WEBPACK_IMPORTED_MODULE_0__.object
    })
]);
/* harmony default export */ __webpack_exports__["Z"] = (forwardRef);


/***/ }),

/***/ 53863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "UE": function() { return /* binding */ isNotEmpty; },
/* harmony export */   "bT": function() { return /* binding */ isUnique; }
/* harmony export */ });
const isString = (value)=>typeof value === "string";
const isUnique = ()=>{
    const processed = new Set();
    return (value)=>{
        if (processed.has(value)) return false;
        processed.add(value);
        return true;
    };
};
const isNotEmpty = (value)=>Boolean(value);


/***/ }),

/***/ 19738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const pureFC = (Component)=>Object.assign(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(Component), Component);
/* harmony default export */ __webpack_exports__["Z"] = (pureFC);


/***/ }),

/***/ 7820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ deepMergeProps; }
/* harmony export */ });
const deepMergeProps = (obj1, obj2)=>{
    // Create a new object that combines the properties of both input objects
    const merged = {
        ...obj1,
        ...obj2
    };
    const keys = Object.keys(merged);
    // Loop through the properties of the merged object
    keys.forEach((key)=>{
        // Check if the property is an object
        if (typeof merged[key] === "object" && merged[key] !== null) {
            // If the property is an object, recursively merge the objects
            merged[key] = deepMergeProps(obj1[key] ? obj1[key] : {}, obj2[key] ? obj2[key] : {});
        }
    });
    return merged;
};
const isPlainObject = (value)=>typeof value === "object" && value !== null && [
        Object,
        undefined
    ].includes(value.constructor);
const isEmptyObject = (value)=>isPlainObject(value) && Object.getOwnPropertyNames(value).length === 0;
const filter = function(obj) {
    let processed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Set();
    // Preventing circular references
    if (processed.has(obj)) throw new TypeError("Cannot process Object with circular references");
    const result = {};
    processed.add(obj);
    Object.getOwnPropertyNames(obj).forEach((name)=>{
        const value = obj[name];
        const processedValue = isPlainObject(value) ? filter(value, processed) : value;
        if (processedValue == null || isEmptyObject(processedValue)) return;
        result[name] = processedValue;
    });
    return result;
};
const removeEmptyProps = (obj)=>isPlainObject(obj) ? filter(obj) : {};
/* harmony default export */ __webpack_exports__["Z"] = (removeEmptyProps);


/***/ }),

/***/ 70627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "VF": function() { return /* binding */ push; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "zh": function() { return /* binding */ transduce; }
/* harmony export */ });
/* harmony import */ var _fn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46393);
/* eslint-disable prettier/prettier */ 
const map = (mapper)=>(reducer)=>(accumulator, item, index, arr)=>reducer(accumulator, mapper(item, index, arr), index, arr);
const filter = (predicate)=>(reducer)=>(accumulator, item, index, arr)=>predicate(item, index, arr) ? reducer(accumulator, item, index, arr) : accumulator;
const push = (list, item)=>{
    list.push(item);
    return list;
};
const transduce = function(list, reducer, initialValue) {
    for(var _len = arguments.length, transducers = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        transducers[_key - 3] = arguments[_key];
    }
    return list.reduce((0,_fn__WEBPACK_IMPORTED_MODULE_0__/* .compose */ .qC)(...transducers)(reducer), initialValue);
};


/***/ }),

/***/ 46003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_t": function() { return /* reexport */ i18_WithLocale; },
  "bU": function() { return /* reexport */ hook; }
});

// UNUSED EXPORTS: LocaleProvider

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/context.js



let warn = (action)=>{
    // eslint-disable-next-line no-console
    console.warn(action, "\nThe localization context is absent. Use LocaleProvider");
    warn = ()=>{}; // no more messages
};
const FAKE_TRANSLATOR_API = {
    i18: {
        t: (key)=>{
            warn('Cannot get text for key "'.concat(key, '"'));
            return key;
        },
        getFixedT: ()=>{
            warn("Cannot bind namespace or language.");
            return (key)=>key;
        }
    },
    subscribe: ()=>{
        warn("Cannot subscribe on localization events.");
    },
    setLanguage: ()=>{
        warn("Cannot set language.");
        return Promise.resolve();
    },
    release: ()=>{
        warn("Cannot unsubsribe from localization events.");
    }
};
const i18Context = /*#__PURE__*/ react.createContext(FAKE_TRANSLATOR_API);
const I18Provider = (param)=>/*#__PURE__*/ {
    let { translator , children  } = param;
    return (0,jsx_runtime.jsx)(i18Context.Provider, {
        value: translator,
        children: children
    });
};
I18Provider.propTypes = {
    translator: (0,prop_types.shape)({
        setLanguage: prop_types.func.isRequired,
        subscribe: prop_types.func.isRequired,
        i18: prop_types.object
    }).isRequired,
    children: prop_types.node
};
/* harmony default export */ var context = (i18Context);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/useIsoEffect.js

const useIsoEffect =  false ? 0 : react.useLayoutEffect;

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/hook.js



function useLocale(namespace) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const translator = (0,react.useContext)(context);
    const { i18 , subscribe , setLanguage  } = translator;
    const [language, setLng] = (0,react.useState)(i18.language);
    const $t = (0,react.useMemo)(()=>i18.getFixedT(i18.language, namespace), [
        i18.language,
        namespace
    ]);
    useIsoEffect(()=>subscribe((lng)=>{
            if (language === lng) return;
            if (options.log) {
                // eslint-disable-next-line no-console
                console.log(options.log, "useLocale.subscription", {
                    lng,
                    language,
                    l: i18.language
                });
            }
            setLng(lng);
        }), [
        setLng,
        language
    ]);
    useIsoEffect(()=>{
        if (options.log) {
            // eslint-disable-next-line no-console
            console.log(options.log, "useLocale", {
                language,
                l: i18.language
            });
        }
    }, [
        options.log,
        language,
        i18.language
    ]);
    return [
        $t,
        language,
        setLanguage
    ];
}
/* harmony default export */ var hook = (useLocale);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread.js
var objectSpread = __webpack_require__(94334);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(32531);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/node_modules/i18next/dist/esm/i18next.js









var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Logger);

    this.init(concreteLogger, options);
  }

  (0,createClass/* default */.Z)(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, (0,objectSpread/* default */.Z)({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    (0,classCallCheck/* default */.Z)(this, EventEmitter);

    this.observers = {};
  }

  (0,createClass/* default */.Z)(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (typeof mix === 'string') return mix;
      if (p && typeof mix[p] === 'string') return mix[p];
      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  (0,inherits/* default */.Z)(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    (0,classCallCheck/* default */.Z)(this, ResourceStore);

    _this = (0,possibleConstructorReturn/* default */.Z)(this, (0,getPrototypeOf/* default */.Z)(ResourceStore).call(this));

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  (0,createClass/* default */.Z)(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = (0,objectSpread/* default */.Z)({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return (0,objectSpread/* default */.Z)({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, Translator);

    _this = (0,possibleConstructorReturn/* default */.Z)(this, (0,getPrototypeOf/* default */.Z)(Translator).call(this));

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, (0,assertThisInitialized/* default */.Z)(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  (0,createClass/* default */.Z)(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if ((0,esm_typeof/* default */.Z)(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, (0,objectSpread/* default */.Z)({}, options, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, (0,objectSpread/* default */.Z)({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, (0,objectSpread/* default */.Z)({}, options, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, fallbackValue) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : resForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : resForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init((0,objectSpread/* default */.Z)({}, options, {
          interpolation: (0,objectSpread/* default */.Z)({}, this.options.interpolation, options.interpolation)
        }));
        var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = (0,objectSpread/* default */.Z)({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? (0,objectSpread/* default */.Z)({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    (0,classCallCheck/* default */.Z)(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.supportedLngs || false;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  (0,createClass/* default */.Z)(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
      return this.isSupportedCode(code);
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    (0,classCallCheck/* default */.Z)(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  (0,createClass/* default */.Z)(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      return this.getSuffixes(code).map(function (suffix) {
        return key + suffix;
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var rule = this.getRule(code);

      if (!rule) {
        return [];
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        };

        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0,classCallCheck/* default */.Z)(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  (0,createClass/* default */.Z)(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, (0,objectSpread/* default */.Z)({}, options, data, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, (0,objectSpread/* default */.Z)({}, options, data, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          value = handleFormat(match[1].trim());

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += safeValue.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = (0,objectSpread/* default */.Z)({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = (0,objectSpread/* default */.Z)({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, (0,objectSpread/* default */.Z)({}, options, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  (0,inherits/* default */.Z)(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    (0,classCallCheck/* default */.Z)(this, Connector);

    _this = (0,possibleConstructorReturn/* default */.Z)(this, (0,getPrototypeOf/* default */.Z)(Connector).call(this));

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, (0,objectSpread/* default */.Z)({}, options, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    whitelist: false,
    nonExplicitWhitelist: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if ((0,esm_typeof/* default */.Z)(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if ((0,esm_typeof/* default */.Z)(args[2]) === 'object' || (0,esm_typeof/* default */.Z)(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: false
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.whitelist) {
    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
      options.whitelist = options.whitelist.concat(['cimode']);
    }

    options.supportedLngs = options.whitelist;
  }

  if (options.nonExplicitWhitelist) {
    options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
  }

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function noop() {}

var I18n = function (_EventEmitter) {
  (0,inherits/* default */.Z)(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    (0,classCallCheck/* default */.Z)(this, I18n);

    _this = (0,possibleConstructorReturn/* default */.Z)(this, (0,getPrototypeOf/* default */.Z)(I18n).call(this));

    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return (0,possibleConstructorReturn/* default */.Z)(_this, (0,assertThisInitialized/* default */.Z)(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  (0,createClass/* default */.Z)(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (options.whitelist && !options.supportedLngs) {
        this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
      }

      if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) {
        this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
      }

      this.options = (0,objectSpread/* default */.Z)({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if ((0,esm_typeof/* default */.Z)(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = (0,objectSpread/* default */.Z)({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = keyPrefix ? "".concat(keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = (0,objectSpread/* default */.Z)({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = (0,objectSpread/* default */.Z)({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages
      };
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

/* harmony default export */ var esm_i18next = (i18next);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/Emitter/subscriptions.js
var subscriptions = __webpack_require__(12300);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/formats/format.js
const formats = new Map();
const register = function(formatFunction) {
    let name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : formatFunction.name;
    formats.set(name, formatFunction);
};
const parseJson = (v)=>{
    try {
        return JSON.parse(v);
    } catch (e) {
        return v;
    }
};
const parseFormat = (formatString)=>{
    const res = /([a-z]+)(?:\(([^()]+)\))?/i.exec(formatString) || [];
    return [
        res[1],
        res[2] ? res[2].split(/\s*,\s*/).map(parseJson) : []
    ];
};
const format = (value, formatString, lang)=>{
    const [formatName, args] = parseFormat(formatString);
    if (!formatName) return value;
    const formatter = formats.get(formatName);
    return typeof formatter === "function" ? formatter(value, lang, ...args) : value;
};

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/formats/currency.js
const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});
const currency = (amount)=>{
    const parsed = typeof amount === "string" ? parseFloat(amount) : amount;
    return typeof parsed === "number" && !Number.isNaN(parsed) ? currencyFormatter.format(parsed) : amount;
};
/* harmony default export */ var formats_currency = (currency);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/formats/padding.js
const padding_toString = (value)=>value != null ? value.toString() : "";
const ensureString = (value)=>typeof value !== "string" ? padding_toString(value) : value;
const padLeft = (value, width)=>ensureString(value).padEnd(width);
const padRight = (value, width)=>ensureString(value).padStart(width);
const padding = (value, lang, width)=>width > 0 // checking if widht positive
     ? padLeft(value, width) : padRight(value, -width);
/* harmony default export */ var formats_padding = (padding);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/formats/date-formats.js
const shortDateFormatter = new Intl.DateTimeFormat("en", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
});
const longDateFormatter = new Intl.DateTimeFormat("en", {
    day: "2-digit",
    month: "long",
    year: "numeric"
});
const midDateFormatter = new Intl.DateTimeFormat("en", {
    day: "2-digit",
    month: "short",
    year: "numeric"
});
const shortDate = (value)=>shortDateFormatter.format(new Date(value));
const longDate = (value)=>longDateFormatter.format(new Date(value));
const midDate = (value)=>midDateFormatter.format(new Date(value));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/formats/str.js
const slice = (value, lang, start, end)=>typeof value === "string" ? value.slice(start, end) : value;
const right = (value, lang, count)=>slice(value, lang, -count, undefined);
const left = (value, lang, count)=>slice(value, lang, 0, count);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/formats/negative-parences.js

/**
 * Decorates number-formatter with wrapping negative values with parences
 *
 * @type {(formatter: (value: number) => string) => (value: number) => string} */ const negativeParences = (formatter)=>(value)=>value < 0 ? "(".concat(formatter(-value), ")") : formatter(value);
const currencyNp = negativeParences(formats_currency);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/formats/list.js
const list = function(items, lang) // prettier-ignore
{
    let conjunction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "common:AND";
    return !Array.isArray(items) ? items : items.length === 0 ? "" : items.length === 1 ? items[0] : items.length === 2 ? items.join(" $t(".concat(conjunction, ") ")) : [
        items.slice(0, -1).join(", "),
        items[items.length - 1]
    ].join(" $t(".concat(conjunction, ") "));
};
/* harmony default export */ var formats_list = (list);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/formats/join.js
const join = function(items, lang) {
    let conjunction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ", ";
    return !Array.isArray(items) ? items : items.join(conjunction);
};
/* harmony default export */ var formats_join = (join);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/formats/en.js








register(formats_currency);
register(formats_currency, "CCY");
register(currencyNp);
register(currencyNp, "ACCY");
register(formats_padding);
register(formats_padding, "PAD");
register(shortDate);
register(shortDate, "DATE");
register(longDate);
register(longDate, "LONGDATE");
register(midDate);
register(midDate, "MIDDATE");
register(slice);
register(slice, "SLICE");
register(slice, "SUBSTR");
register(left);
register(left, "LEFT");
register(right);
register(right, "RIGHT");
register(formats_list);
register(formats_list, "LIST");
register(formats_join);
register(formats_join, "JOIN");
/* harmony default export */ var en = (format);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/translator.js



const translator = (param)=>{
    let { parent , resources , ...options } = param;
    const { subscribe , notify  } = (0,subscriptions/* default */.Z)();
    const i18 = esm_i18next.createInstance();
    i18.init({
        whitelist: Object.keys(resources),
        ns: [
            "common"
        ],
        defaultNS: "common",
        fallbackLng: "en",
        fallbackNS: [
            "common"
        ],
        interpolation: {
            escapeValue: false,
            format: en
        },
        returnObjects: true,
        resources,
        partialBundledLanguages: true,
        overloadTranslationOptionHandler: (param)=>{
            let [, opts] = param;
            return {
                value: opts
            };
        },
        ...options,
        language: options.lng || "en",
        lng: options.lng || "en"
    });
    const handleUpdates = ()=>notify(i18.language, i18);
    i18.on("languageChanged", handleUpdates);
    const setLanguage = (lang)=>{
        if (lang !== i18.language) {
            i18.changeLanguage(lang);
        }
        if (parent != null && typeof parent.changeLanguage === "function") {
            parent.changeLanguage(lang);
        }
    };
    if (parent != null && typeof parent.on === "function") {
        parent.on("languageChange", setLanguage);
        setLanguage(parent.language);
    }
    const release = ()=>{
        if (parent != null && typeof parent.off === "function") {
            parent.off("languageChange", setLanguage);
        }
    };
    return {
        setLanguage,
        i18,
        subscribe,
        release
    };
};
/* harmony default export */ var i18_translator = (translator);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/LocaleProvider.js






const LocaleProvider = (param)=>{
    let { language , resources , children , ...options } = param;
    const currentContext = (0,react.useContext)(context);
    const parent = currentContext === null || currentContext === void 0 ? void 0 : currentContext.i18;
    var ref;
    const lang = (ref = parent === null || parent === void 0 ? void 0 : parent.language) !== null && ref !== void 0 ? ref : language; // eslint-disable-line
    const translator = (0,react.useMemo)(()=>i18_translator({
            parent,
            resources,
            ...options,
            lng: lang
        }), [
        language,
        parent
    ]);
    useIsoEffect(()=>translator.release, [
        translator
    ]);
    useIsoEffect(()=>{
        if (lang === translator.i18.language) return;
        translator.setLanguage(lang);
    }, [
        lang,
        translator
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context.Provider, {
        value: translator,
        children: children
    });
};
LocaleProvider.propTypes = {
    language: prop_types.string,
    resources: prop_types.object.isRequired,
    children: prop_types.node
};
/* harmony default export */ var i18_LocaleProvider = (LocaleProvider);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/WithLocale.js



var ref;
const getComponentName = function(param) {
    let { displayName , name  } = param, defaultName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Unknown";
    return (ref = displayName !== null && displayName !== void 0 ? displayName : name) !== null && ref !== void 0 ? ref : defaultName;
};
const WithLocale = function() {
    let { resources , ...options } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (Component)=>{
        const ComponentWithLocale = (props)=>{
            var _resources;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(i18_LocaleProvider, {
                resources: (_resources = Component.resources) !== null && _resources !== void 0 ? _resources : resources,
                ...options,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                    ...props
                })
            });
        };
        Object.assign(ComponentWithLocale, Component);
        ComponentWithLocale.displayName = "WithLocale(".concat(getComponentName(Component), "))");
        return ComponentWithLocale;
    };
};
/* harmony default export */ var i18_WithLocale = (WithLocale);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/i18/index.js





/***/ }),

/***/ 93745:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.vmap = exports.summ = exports.some = exports.skipIf = exports.resolve = exports.reject = exports.promisify = exports.orderWith = exports.order = exports.mergeProps = exports.mergeAll = exports.merge = exports.mapErrors = exports.isPromise = exports.isLoaded = exports.isFunc = exports.isEmpty = exports.idX = exports.get = exports.every = exports.ensureFunc = exports.compose2 = exports.compose = exports.callWith = exports.callWhenReady = exports.call = exports.asyncAll = exports.asAsync = void 0;
/**
 * Type `Fn<Args extends any[], R>` - Generic Function
 *
 * @template {any[]} A
 * @template R
 * @typedef {(...args: A) => R} Fn
 */ /**
 * Type `Callback<Err extends Error, Res>` - Generic First-Error Callback
 *
 * @template {Error} E
 * @template R
 * @typedef {(error: E, result: R) => void} Callback
 */ /**
 * Type `CompareFn<T>` - Generic Compare Function
 *
 * @template T
 * @typedef {(item: T, list: T[], index: number) => number} CompareFn
 */ /**
 * Type `SyncType<T>` - Type extracts type packed into the Promise
 *
 * @template T
 * @typedef {T extends Promise<infer Packed> ? Packed : T} SyncType
 */ /**
 * Identiry Function
 *
 * @see https://en.wikipedia.org/wiki/Identity_function
 *
 * @type <T>(x: T) => T
 */ const idX = (x)=>x;
/**
 * Creates applicator: the function that call its argument with arguments
 * specified when applicator has been created
 *
 * @type {<A extends any[]>(...args: A) => <R>(fn: Fn<A, R>) => R}
 */ exports.idX = idX;
const call = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return (fn)=>fn(...args);
};
/**
 * Checks if argument is a Promise or not (actualy if argument is thanable)
 *
 * @type {(value: any) => value is Promise<any>}
 */ exports.call = call;
const isPromise = (value)=>value != null && typeof value.then === "function";
/**
 * Checks if argument is a Function
 *
 * @type {(value: any) => value is Function}
 */ exports.isPromise = isPromise;
const isFunc = (value)=>typeof value === "function";
/**
 * Replaces the first argument with the second one if the the first is not a Function
 *
 * @type {<T>(value: any, def: T) => Function | T}
 */ exports.isFunc = isFunc;
const ensureFunc = (value, def)=>isFunc(value) ? value : def;
/**
 * Composes two function:
 *
 * @example
 * const f = x => x + 1;
 * const g = x => x * 2;
 * const h = compose(f, g);
 * const h_ = x => f(g(x)); // the same as h
 *
 * @type {<A extends any[], R2, R1>(f1: (arg: R2) => R1, f2: (...args: A) => R2) => (...args: A) => R1}
 *
 */ exports.ensureFunc = ensureFunc;
const compose2 = (f, g)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return f(g(...args));
    };
/**
 * Composes any number of functions.
 * 
 * @type {{
  (): <T>(x: T) => T

  <A extends any[], R>(f: (...args: A) => R): (...args: A) => R;

  <A extends any[], R2, R1>(
    f1: (arg: R2) => R1,
    f2: (...args: A) => R2
  ): (...args: A) => R1;
  
  <A extends any[], R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (...args: A) => R3
  ): (...args: A) => R1;
  
  <A extends any[], R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (...args: A) => R4
  ): (...args: A) => R1;
  
  <A extends any[], R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (...args: A) => R5
  ): (...args: A) => R1;
  
  <A extends any[], R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (...args: A) => R6
  ): (...args: A) => R1;
  
  <A extends any[], R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (...args: A) => R7
  ): (...args: A) => R1;
  
  <A extends any[], R8, R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (arg: R8) => R7,
    f8: (...args: A) => R8
  ): (...args: A) => R1;
  
  <A extends any[], R9, R8, R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (arg: R8) => R7,
    f8: (arg: R9) => R8,
    f9: (...args: A) => R9
  ): (...args: A) => R1;
  
  <A extends any[], RA, R9, R8, R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (arg: R8) => R7,
    f8: (arg: R9) => R8,
    f9: (arg: RA) => R9,
		fa: (...args: A) => RA;

	<A extends any[], RB, RA, R9, R8, R7, R6, R5, R4, R3, R2, R1>(
    f1: (arg: R2) => R1,
    f2: (arg: R3) => R2,
    f3: (arg: R4) => R3,
    f4: (arg: R5) => R4,
    f5: (arg: R6) => R5,
    f6: (arg: R7) => R6,
    f7: (arg: R8) => R7,
    f8: (arg: R9) => R8,
		f9: (arg: RA) => R9,
		fa: (arg: RB) => RA,
    fb: (...args: A) => RB
  ): (...args: A) => R1;
  
  (...fns: Function[]): Function;
}} */ exports.compose2 = compose2;
const compose = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return fns.length > 0 ? fns.reduce(compose2) : idX;
};
/**
 * Re-throws error mapped with `errorsMapper`.
 *
 * If `errorsMapper` return falsy value the original error will be re-thrown
 *
 * @type {<E1 extends Error, E2 extends Error>(errorsMapper: Fn<[E1], E2 | null | undefined>) => (e: E1) => never}
 */ exports.compose = compose;
const mapErrors = (errorsMapper)=>(err)=>{
        throw errorsMapper(err) || err;
    };
/**
 * Decorator Factory `skipIf` adds effect of replace decorated function (`fn`) call with
 * call of `altFn` if `predicate` returns truthy value.
 *
 * if `altFn` is not specified the [identity](#idX) function will be used
 *
 * @type {<A extends any[], TA>(predicate: Fn<A, boolean>, altFn?: Fn<A, TA>) => <T>(fn: Fn<A, T>) => Fn<A, T | TA>}
 */ exports.mapErrors = mapErrors;
const skipIf = function() {
    let predicate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ()=>true, altFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : idX;
    return (fn)=>function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return predicate(...args) ? altFn(...args) : fn(...args);
        };
};
/**
 * Checks if value is null or undefined
 *
 * @type {(value: any) => value is null | undefined}
 */ exports.skipIf = skipIf;
const isEmpty = (value)=>value == null;
/**
 * Mergers list of objects to the new one
 *
 * @type <T extends {}>(objects: Array<{}>) => T}
 */ exports.isEmpty = isEmpty;
const mergeAll = (props)=>Object.assign({}, ...props);
/**
 * Merges two or more objects some of those could be an async
 *
 * @type {{
 *  <T>(...props: Array<{}>): T
 *  <T>(...props: Array<{} | Promise<{}>>): Promise<T>
 * }}
 */ exports.mergeAll = mergeAll;
const mergeProps = function() {
    for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++){
        props[_key] = arguments[_key];
    }
    return props.some(isPromise) ? Promise.all(props).then(mergeAll) : mergeAll(props);
};
/**
 * Creates applicator: the function that call its argument with arguments
 * specified when applicator has been created
 */ exports.mergeProps = mergeProps;
const callWith = exports.callWith = call;
const promiseCallback = (resolve, reject)=>(err, result)=>err ? reject(err) : resolve(result);
/**
 * Converts error-first callbacked async function to function returns a promise
 *
 * @type {<A extends any[], E extends Error, R>(fn: (...args: A, cb: Callback<E, R>) => void) => Fn<A, Promise<R>>}
 */ const promisify = (fn)=>function promisified() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return new Promise((resolve, reject)=>fn.apply(this, args.concat(promiseCallback(resolve, reject))));
    };
/**
 * Calls error-first callbacked async funcation and returns a promise
 *
 * @type {<A extends any[], E extends Error, R>(fn: (...args: A, cb: Callback<E, R>) => void) => Promise<R>}
 */ exports.promisify = promisify;
const asAsync = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return new Promise((resolve, reject)=>fn(...args, promiseCallback(resolve, reject)));
};
/**
 * Mergers argument objects to the new one
 *
 * @type <T extends {}>(...partials: Array<{}>) => T}
 */ exports.asAsync = asAsync;
const merge = function() {
    for(var _len = arguments.length, partials = new Array(_len), _key = 0; _key < _len; _key++){
        partials[_key] = arguments[_key];
    }
    return Object.assign({}, ...partials);
};
/**
 * Sums two numbers
 *
 * Function created to be used as reducer
 *
 * @type {(a: number, b: number) => number}
 */ exports.merge = merge;
const summ = (a, b)=>a + b;
/**
 * Creates a getter for field or index.
 *
 * @type {{
 * (index: number): <C extends Array<any> | null>(container?: C) => C extends Array<infer T> ? T : C;
 * <N extends string | symbol>(field: N): <C extends { } | null>(container?: C) =>
 *   C extends null | undefined ? C :
 *   C extends { [p in N]?: infer T } ? T :
 *   undefined;
 * }}
 */ exports.summ = summ;
const get = (fieldOrIndex)=>(container)=>container && container[fieldOrIndex];
exports.get = get;
const order2 = (sort1, sort2)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return sort1(...args) || sort2(...args);
    };
/**
 * Creates a complex comparing function based on the argument comparing functions
 *
 * @type {<T>(...sorters: CompareFn<T>[]) => CompareFn<T>}
 */ const order = function() {
    for(var _len = arguments.length, sorters = new Array(_len), _key = 0; _key < _len; _key++){
        sorters[_key] = arguments[_key];
    }
    return sorters.reduce(order2);
};
/**
 * Basing on argument comparing functions creates a function that sorts an array
 *
 * Function returns a new Array.
 *
 * @template T
 * @typedef {(item: T, list: T[], index: number) => number} CompareFn
 * @type {<T>(...sorters: CompareFn<T>[]) => <S extends T>(list: S[]) => S[]}
 */ exports.order = order;
const orderWith = function() {
    for(var _len = arguments.length, sorters = new Array(_len), _key = 0; _key < _len; _key++){
        sorters[_key] = arguments[_key];
    }
    const compare = order(...sorters);
    return (list)=>list.slice().sort(compare);
};
/**
 * Builds new function from the arguments.
 * New function calls argument-functions and return promise that resolves
 * with array of results returned by correspondent argument function.
 *
 * @type {{
   (): () => Promise<[]>;

  <A extends any[], R1>(f1: Fn<A, R1>): (...args: A) => Promise<[SyncType<R1>]>;

  <A extends any[], R1, R2>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>
  ): (...args: A) => Promise<[SyncType<R1>, SyncType<R2>]>;

  <A extends any[], R1, R2, R3>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>
  ): (...args: A) => Promise<[SyncType<R1>, SyncType<R2>, SyncType<R3>]>;

  <A extends any[], R1, R2, R3, R4>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6, R7>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
    f7: Fn<A, R7>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
    SyncType<R7>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6, R7, R8>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
    f7: Fn<A, R7>,
    f8: Fn<A, R8>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
    SyncType<R7>, SyncType<R8>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6, R7, R8, R9>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
    f7: Fn<A, R7>,
    f8: Fn<A, R8>,
    f9: Fn<A, R9>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
    SyncType<R7>, SyncType<R8>, SyncType<R9>,
  ]>;

  <A extends any[], R1, R2, R3, R4, R5, R6, R7, R8, R9, RA>(
    f1: Fn<A, R1>,
    f2: Fn<A, R2>,
    f3: Fn<A, R3>,
    f4: Fn<A, R4>,
    f5: Fn<A, R5>,
    f6: Fn<A, R6>,
    f7: Fn<A, R7>,
    f8: Fn<A, R8>,
    f9: Fn<A, R9>,
    fa: Fn<A, RA>,
  ): (...args: A) => Promise<[
    SyncType<R1>, SyncType<R2>, SyncType<R3>,
    SyncType<R4>, SyncType<R5>, SyncType<R6>,
    SyncType<R7>, SyncType<R8>, SyncType<R9>,
    SyncType<RA>,
  ]>;

  <A extends any[], R1>(...fns: Fn<A,R>[]): (...args: A) => Promise<SyncType<R>[]>;
 }}
 */ exports.orderWith = orderWith;
const asyncAll = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return Promise.all(fns.map(call(...args)));
    };
};
/**
 * Creates array predicate from item predicate.
 * New predicate returns true if and only if item predicate returns true for each array item
 *
 * @type {<T>(predicate: (item: T, list: T[], index: number) => boolean) => <S extends T>(list: S[]) => boolean}
 */ exports.asyncAll = asyncAll;
const every = (predicate)=>(list)=>list.every(predicate);
/**
 * Creates array predicate from item predicate.
 * New predicate returns true if and only if item predicate returns true for any of array items
 *
 * @type {<T>(predicate: (item: T, list: T[], index: number) => boolean) => <S extends T>(list: S[]) => boolean}
 */ exports.every = every;
const some = (predicate)=>(list)=>list.some(predicate);
/**
 * Checks if value is not null or undefined
 */ exports.some = some;
const isLoaded = (value)=>value != null;
/**
 * Maps `value` with `mapper`
 * `value` could be an array or an single value.
 *
 * If `value` is an array the vmap returns napped array
 * otherwise vamap returns single mapped value
 *
 * @type {{
 *  <T, S>(mapper: (item: T, list: T[] | null, index: number) => S): <V extends T|T[]>(value: V) => V extends T[] ? S[] : S
 * }}
 */ exports.isLoaded = isLoaded;
const vmap = (mapper)=>(value)=>Array.isArray(value) ? value.map(mapper) : mapper(value, null, 0);
/** Calls fn function when value is resolved.
 * If value is not a promise the fn will be called immediately.
 *
 * @type {<T, R>(fn: (value: T|Promise<T>) => R, value: T | Promise<T>) => V extends Promise<T> ? Promise<R> : R}
 * */ exports.vmap = vmap;
const callWhenReady = (fn, value)=>isPromise(value) ? value.then(fn) : fn(value);
exports.callWhenReady = callWhenReady;
const resolve = (value)=>Promise.resolve(value);
exports.resolve = resolve;
const reject = (error)=>Promise.reject(error);
exports.reject = reject;


/***/ }),

/***/ 38733:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = exports.ZP = void 0;
var _ = __webpack_require__(93745);
const pipe = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>fn(val), value);
};
const pipeA = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>(0, _.isPromise)(val) ? val.then(fn) : fn(val), //
    value //
    );
};
__webpack_unused_export__ = pipeA;
pipe.async = pipeA;
var _default = exports.ZP = pipe;


/***/ }),

/***/ 27639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ shared_utils_memo; },
  "nJ": function() { return /* binding */ memo1; }
});

// UNUSED EXPORTS: memo2, memo3, memoFactory, slice

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/memo/dictionary.js
const Node = ()=>({
        next: new Map()
    });
const add = (root)=>(tokens, value)=>{
        const leaf = tokens.reduce((node, token)=>{
            const subNode = node.next.get(token);
            if (subNode) return subNode;
            const newNode = Node();
            node.next.set(token, newNode);
            return newNode;
        }, root);
        leaf.value = value;
    };
const get = (root)=>(tokens)=>{
        let node = root;
        const l = tokens.length;
        for(let i = 0; node && i < l; i += 1){
            node = node.next.get(tokens[i]);
        }
        return node && node.value;
    };
const DictionaryAPI = (root)=>({
        add: add(root),
        get: get(root)
    });
const Dictionary = ()=>DictionaryAPI(Node());
/* harmony default export */ var dictionary = (Dictionary);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/memo/index.js


/**
 * Creates memoization function
 *
 * @type {(getKey: (args: any[]) => any) => <A extends any[], R>(fn: (...args: A) => R) => (...args: A) => R}
 */ const memoFactory = (getKey)=>(fn)=>{
        // Avoiding memoization on the server-side
        if (false) {}
        const cache = dictionary();
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            const key = getKey(args);
            const result = cache.get(key);
            if (result) return result.value;
            const value = fn(...args);
            cache.add(key, {
                value
            });
            return value;
        };
    };
/**
 * Memoize function using all arguments as cache key
 *
 * @type {{
 *   <A extends any[], R>(fn: (...args: A) => R) => (...args: A) => R;
 *   n: (n: number) => <A extends any[], R>(fn: (...args: A) => R) => (...args: A) => R;
 * }}
 */ const memo = memoFactory(fn/* idX */.Yr);
/**
 * Creates slicer for list
 *
 * @type {(start: number, end: number) => <T>(list: T[]) => T[]}
 */ const slice = (start, end)=>(list)=>list.slice(start, end);
/**
 * Memoize function using the first one argument as cache key
 */ const memo1 = memoFactory(slice(0, 1));
/**
 * Memoize function using the first two arguments as cache key
 */ const memo2 = memoFactory(slice(0, 2));
/**
 * Memoize function using the first three arguments as cache key
 */ const memo3 = memoFactory(slice(0, 3));
/**
 * Creates memoization function that memoizes using the first `n` arguments as cache key
 */ memo.n = (n)=>memoFactory(slice(0, n));
/* harmony default export */ var shared_utils_memo = (memo);


/***/ }),

/***/ 5098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);
/* harmony import */ var _events_handlers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28763);






function NextLink(param) {
    let { Component =_insightfulscience_atomic_react_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z , href , as , onClick , active , ...props } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const followLink = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>!active ? (0,_events_handlers__WEBPACK_IMPORTED_MODULE_4__/* .handleWith */ .Gy)(onClick, _events_handlers__WEBPACK_IMPORTED_MODULE_4__/* .prevent */ .X$, ()=>router.push(href, as)) : _events_handlers__WEBPACK_IMPORTED_MODULE_4__/* .prevent */ .X$, [
        href,
        as,
        onClick,
        active
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
        ...props,
        href: as || href,
        onClick: followLink
    });
}
NextLink.propTypes = {
    Component: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_5__.elementType
    ]),
    href: prop_types__WEBPACK_IMPORTED_MODULE_5__.string.isRequired,
    as: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_5__.func,
    active: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool
};
const NextLinkPure = (props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextLink, {
        ...props,
        Component: "a"
    });
NextLink.Pure = NextLinkPure;
/* harmony default export */ __webpack_exports__["Z"] = (NextLink);


/***/ }),

/***/ 28763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FE": function() { return /* binding */ composeRefs; },
/* harmony export */   "Gy": function() { return /* binding */ handleWith; },
/* harmony export */   "X$": function() { return /* binding */ prevent; },
/* harmony export */   "aV": function() { return /* binding */ asyncHandleWith; },
/* harmony export */   "k$": function() { return /* binding */ setRef; }
/* harmony export */ });
/* unused harmony export stop */
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10455);
/* harmony import */ var _insightfulscience_shared_utils_memo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27639);


const handleWith = function() {
    for(var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++){
        handlers[_key] = arguments[_key];
    }
    const fnHandlers = handlers.filter(_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .isFunc */ .Wl);
    return (event)=>fnHandlers.forEach((0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .call */ .RE)(event));
};
handleWith.m = (0,_insightfulscience_shared_utils_memo__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(handleWith);
const asyncHandleWith = function() {
    let delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100;
    return function() {
        for(var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++){
            handlers[_key] = arguments[_key];
        }
        const fnHandlers = handlers.filter(_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .isFunc */ .Wl);
        return (event)=>setTimeout(()=>fnHandlers.forEach((0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .call */ .RE)(event)), delay);
    };
};
asyncHandleWith.m = (delay)=>(0,_insightfulscience_shared_utils_memo__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(asyncHandleWith(delay));
const prevent = (event)=>{
    event.preventDefault();
};
const stop = (event)=>{
    event.stopPropagation();
};
const setRef = (ref, value)=>{
    if (ref == null) return;
    if ((0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_1__/* .isFunc */ .Wl)(ref)) {
        ref(value);
        return;
    }
    ref.current = value; // eslint-disable-line no-param-reassign
};
const assignRef = (element)=>(ref)=>setRef(ref, element);
const composeRefs = function() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return (element)=>refs.forEach(assignRef(element));
};
composeRefs.m = (0,_insightfulscience_shared_utils_memo__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(composeRefs);


/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperty(obj, key, value) {
  key = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),

/***/ 61120:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 32531:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ 94334:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }
  return target;
}

/***/ }),

/***/ 82963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71002);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97326);


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 83997:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toPropertyKey; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if ((0,esm_typeof/* default */.Z)(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if ((0,esm_typeof/* default */.Z)(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return (0,esm_typeof/* default */.Z)(key) === "symbol" ? key : String(key);
}

/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

}]);